export default class PageFoldForm {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!this.element) return;

        this.btn = this.element.querySelector(".btn");
        this.mainForm = document.querySelector("#sell_contact");

        this.bindEvents();
    }
    bindEvents() {
        Livewire.on("go-to-form", event => {
            this.goToContactForm(event);
        });
        // this.btn.addEventListener("click", e => this.goToContactForm(e));
    }

    goToContactForm(e) {
        const yOffset = -250;
        const y =
            this.mainForm.getBoundingClientRect().top +
            window.pageYOffset +
            yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
    }
}
